import React, { CSSProperties } from 'react';
import { P2 } from 'styleguide/Texts';
import { colors } from 'styleguide/colors';
import { Link } from './Link';
import { formatLink } from 'utils/misc';
import { splitAtUsernamesAndLinks } from 'hevy-shared';

interface LinkableTextProps {
  text?: string;
  style?: CSSProperties;
  onMentionClick?: () => void;
  textStyle?: CSSProperties;
  enableLinks?: boolean;
  enableMentions?: boolean;
}

export const LinkableText = ({
  text,
  style,
  textStyle,
  onMentionClick,
  enableLinks,
  enableMentions,
}: LinkableTextProps) => {
  const format = splitAtUsernamesAndLinks(text || '');

  return (
    <div style={{ ...style }}>
      {format.map((f, index) => {
        if (f.format === '@' && enableMentions) {
          return (
            <Link href={`/user/${f.text.substring(1)}`} onClick={onMentionClick} key={index}>
              <P2 style={{ ...textStyle, color: colors.primary, display: 'inline' }}>{f.text}</P2>
            </Link>
          );
        }

        if (f.format === 'link' && enableLinks) {
          return (
            <a
              href={formatLink(f.text)}
              style={{ textDecoration: 'none' }}
              target="_blank"
              key={index}
              rel="noreferrer"
            >
              <P2 style={{ ...textStyle, color: colors.primary, display: 'inline' }}>{f.text}</P2>
            </a>
          );
        }

        return (
          <P2 key={index} style={{ ...textStyle, display: 'inline' }}>
            {f.text}
          </P2>
        );
      })}
    </div>
  );
};
